// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackToPlp_backButton____f7X"};